import {FormattedDate} from 'react-intl';

import {createElement, PropTypes} from 'rlink-react';
import {DAY, MONTH, YEAR, PLEASE_SELECT, TODAY} from 'rlink-forms/labels';
import {mergeStaticOptions} from 'rlink-utils/object';

import InputBase from './InputBase';

export default class DateInput extends InputBase {


  get minYear () {
    return this.fromPropsOrContext('minYear');
  }

  get maxYear () {
    return this.fromPropsOrContext('maxYear');
  }

  get requireAge () {
    return this.fromPropsOrContext('requireAge');
  }

  get unsetLabel () {
    return this.fromPropsOrContext('unsetLabel');
  }

  get dayFormat () {
    return this.fromPropsOrContext('dayFormat');
  }

  get monthFormat () {
    return this.fromPropsOrContext('monthFormat');
  }

  get yearFormat () {
    return this.fromPropsOrContext('yearFormat');
  }

  get day () {
    if (this.value) {
      return this.value.getDate();
    } else {
      return this.state.day;
    }
  }

  get month () {
    if (this.value) {
      return this.value.getMonth();
    } else {
      return this.state.month;
    }
  }

  get year () {
    if (this.value) {
      return this.value.getFullYear();
    } else {
      return this.state.year;
    }
  }

  get days () {
    let maxDaysDate = new Date(
      isNaN(Number(this.year)) ? 2000 : Number(this.year),
      isNaN(Number(this.month)) ? 0 : Number(this.month) + 1,
      0
    );
    let maxDays = maxDaysDate.getDate();
    let days = [];
    for (let i = 1; i <= maxDays; i++) {
      let date = new Date(maxDaysDate.getFullYear(), maxDaysDate.getMonth(), i);
      days.push(<FormattedDate
        key={i}
        value={date}
        day={this.dayFormat}>
        {formattedDate => <option value={i}>
          {formattedDate}
        </option>}
      </FormattedDate>);
    }
    return days;
  }

  get years () {
    let years = [];
    for (let i = this.maxYear; i >= this.minYear; i--) {
      let date = new Date(i, 0, 1);
      years.push(<FormattedDate
        key={i}
        value={date}
        year={this.yearFormat}>
        {formattedDate => <option value={i}>
          {formattedDate}
        </option>}
      </FormattedDate>);
    }

    return years;
  }

  get months () {
    let months = [];
    for (let i = 0; i < 12; i++) {
      let date = new Date(2000, i, 10);
      months.push(<FormattedDate
        key={i}
        value={date}
        month={this.monthFormat}>
        {formattedDate => <option value={i}>
          {formattedDate}
        </option>}
      </FormattedDate>);
    }
    return months;
  }

  updateDate (ev, field) {
    let newValue = ev.target.value;
    this.setState({
      [field]: newValue,
    }, () => {
      let dateStruct = this.getDateStruct();

      dateStruct[field] = newValue;

      let dateUTC = this.constructUTCDate(dateStruct);
      let timeZoneOffset = this.constructLocalDate(dateStruct).getTimezoneOffset();
      dateUTC.setMinutes(dateUTC.getMinutes() + timeZoneOffset);
      if (isNaN(dateUTC.valueOf())) {
        dateUTC = undefined;
      }

      this.handleChange({
        event: ev,
        value: dateUTC,
      });

      this.fireCommitValue(ev, dateUTC, null, true);
    });
  }

  getDateStruct () {
    return {
      day: this.day,
      month: this.month,
      year: this.year,
    };
  }

  constructUTCDate (dateStruct) {
    return new Date(Date.UTC(dateStruct.year, dateStruct.month, dateStruct.day));
  }

  constructLocalDate (dateStruct) {
    return new Date(dateStruct.year, dateStruct.month, dateStruct.day);
  }

  legalAge (birthday) {
    if (birthday) {
      let today = new Date();

      // do NOT use UTCYear et al - a bar ID check would use local dates
      let age = today.getFullYear() - birthday.getFullYear();
      if ( today.getMonth() < birthday.getMonth() || today.getDate() < birthday.getDate()) {
        age = age - 1;
      }
      return age;
    }
  }

  addValidationProblems (ev) {
    super.addValidationProblems(ev);

    if (ev.value && isNaN(ev.value.valueOf()) ) {
      this.addProblem(ev, 'INVALID_DATE');
    }

    let age = this.legalAge(ev.value);

    if (this.requireAge
        && (!age
          || age < this.requireAge)) {
      this.addProblem(ev, 'TOO_YOUNG');
    }

  }

  hasValue (value) {
    return !!value;
  }

  inputType () {
    return 'date';
  }

  renderDateSelector () {
    return (<div>
      <select
        className="days"
        value={this.day}
        disabled={this.disabled}
        onChange={ev => this.updateDate(ev, 'day')}>
        <option value="-">{DAY}</option>
        <optgroup label={PLEASE_SELECT}>
          {this.days}
        </optgroup>
      </select>
      <select
        className="months"
        value={this.month}
        disabled={this.disabled}
        onChange={ev => this.updateDate(ev, 'month')}>
        <option value="-">{MONTH}</option>
        <optgroup label={PLEASE_SELECT}>
          {this.months}
        </optgroup>
      </select>
      <select className="years"
        value={this.year}
        disabled={this.disabled}
        onChange={ev => this.updateDate(ev, 'year')}>
        <option value="-">{YEAR}</option>
        <optgroup label={PLEASE_SELECT}>
          {this.years}
        </optgroup>
      </select>
      <button onClick={ev => {
        ev.preventDefault();
        let now = new Date();
        let dateUTC = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());

        this.handleChange({
          event: ev,
          value: dateUTC,
        });

        this.fireCommitValue(ev, dateUTC, null, true);
      }}>
        {TODAY}
      </button>
    </div>);
  }


  toggleEnabled (ev) {
    let value = undefined;
    let changes = [];
    if (this.hasValue(this.committedValue)) { // remove this value
      changes = [
        ['RemoveContentValue', {}],
      ];
    } else { // add this value
      let currentTime = new Date();
      let timeZoneOffset = currentTime.getTimezoneOffset();
      value = this.constructUTCDate({
        year: currentTime.getFullYear(),
        month: currentTime.getMonth(),
        day: currentTime.getDate(),
        hour: currentTime.getHours(),
        minute: currentTime.getMinutes(),
      });

      value.setMinutes(value.getMinutes() + timeZoneOffset);
      changes = [
        ['ChangeContentValue', { newValue: value }],
      ];
    }
    this.handleChange({
      event: ev,
      value,
      changes,
    });

    this.fireCommitValue(ev, value, changes, true);
  }

  renderInput () {
    return (<div className="date-select">
      {!this.required && <span className="input-checkbox">
        <label>
          <input
            type="checkbox"
            checked={this.hasValue(this.value)}
            onChange={ev => this.toggleEnabled(ev)} />
          <span className="renderedCheckbox" />
        </label>
      </span>}
      {!this.required
        && !this.hasValue(this.value)
        && this.unsetLabel}
      {(this.required
        || this.hasValue(this.value))
        && this.renderSelectors()}
    </div>);
  }

  renderSelectors () {
    return this.renderDateSelector();
  }
}

mergeStaticOptions(DateInput, {
  propTypes: {
    value: PropTypes.instanceOf(Date),
    committedValue: PropTypes.instanceOf(Date),
    minYear: PropTypes.number,
    maxYear: PropTypes.number,
    requireAge: PropTypes.number,
    unsetLabel: PropTypes.node,
    dayFormat: PropTypes.oneOf([
      'numeric',
      '2-digit',
    ]),
    monthFormat: PropTypes.oneOf([
      'numeric',
      '2-digit',
      'narrow',
      'short',
      'long',
    ]),
    yearFormat: PropTypes.oneOf([
      'numeric',
      '2-digit',
    ]),
  },
  defaultProps: {
    minYear: 1900,
    maxYear: (new Date()).getFullYear(),
    unsetLabel: '(all of the time)',
    dayFormat: 'numeric',
    monthFormat: 'long',
    yearFormat: 'numeric',
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/DateInput.jsx